<template>
  <div class="swipper-slider">
    <template v-if="!isMobile && slides.length" style="min-width: 251px">
      <swiper :options="swiperOption" ref="mySwiper" style="min-width: 251px">
        <!-- slides -->
        <swiper-slide :key="index" v-for="(slide, index) in slides" style="min-width: 251px">
          <salon
            v-if="!slide.adsenseContent"
            :id="slide.id"
            :index="index"
            :name="slide.name"
            :metro="slide.metro"
            :timeToMetro="slide.time_to_metro"
            :metroHexColor="slide.metro_hex_color"
            :address="slide.address"
            :city="slide.city"
            :position="slide.position"
            :employeeCount="slide.employee_count"
            :workingTimeStart="slide.working_time_today.start_time"
            :workingTimeEnd="slide.working_time_today.end_time"
            :isGenderableServices="companySettings.is_genderable_services"
            :cid="cid"
            :distance="slide.distance"
            @onSetPath="$emit('onSetPath', slide.position)"
            @click.native="selectSalon(slide.id)"
          ></salon>
          <div v-if="slide.adsenseContent" class="client-slider__click-wrap ads" :key="index+'_adv'"
               style="min-width: 251px">
            <adsense
              :key="index+'_adv'"
              adClient="ca-pub-3132918828120911"
              adSlot="6695402149"
              adFormat="fluid"
              adStyle="display:block;min-width:251px;max-width:260px;width:100%;height:245px;margin: 0 auto;"
            >
            </adsense>
          </div>
        </swiper-slide>
      </swiper>
    </template>
    <template v-if="isMobile && slides.length" style="min-width: 251px">
      <div :key="index" v-for="(slide, index) in slides" style="min-width: 251px">
        <salon
          v-if="!slide.adsenseContent"
          :id="slide.id"
          :index="index"
          :name="slide.name"
          :metro="slide.metro"
          :timeToMetro="slide.time_to_metro"
          :metroHexColor="slide.metro_hex_color"
          :address="slide.address"
          :city="slide.city"
          :position="slide.position"
          :employeeCount="slide.employee_count"
          :workingTimeStart="slide.working_time_today.start_time"
          :workingTimeEnd="slide.working_time_today.end_time"
          :isGenderableServices="companySettings.is_genderable_services"
          :cid="cid"
          :distance="slide.distance"
          @onSetPath="$emit('onSetPath', slide.position)"
          @click.native="selectSalon(slide.id)"
        ></salon>
        <div v-if="slide.adsenseContent" class="client-slider__click-wrap ads" :key="index+'_adv'"
             style="min-width: 251px">
          <adsense
            :key="index+'_adv'"
            adClient="ca-pub-3132918828120911"
            adSlot="6695402149"
            adFormat="fluid"
            adStyle="display:block;min-width:251px;max-width:260px;width:100%;height:245px;margin: 0 auto;"
          >
          </adsense>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

import 'swiper/dist/css/swiper.css'
import Salon from "@/components/OneSalon/OneSalon.vue";
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import {mapActions, mapState} from "vuex";
import Adsense from '@/components/ADSENSE/Adsense.vue'
import {isMobileDevice} from "../helpers/osChecker";

export default {
  name: "Salons",
  components: {
    Salon,
    swiper,
    swiperSlide,
    Adsense
  },
  props: {
    cid: {type: String},
    salons: {type: Array}
  },
  data() {
    return {
      el: null,
      allSlides: [],
      adsenseContent: '',
      mobilePoint: 425,
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 10,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1600: {
            slidesPerView: 5,
          },
          1380: {
            slidesPerView: 4,
          },
          1175: {
            slidesPerView: 3,
          },
          860: {
            slidesPerView: 2,
          },
          580: {
            slidesPerView: 1,
          }
        }
      },
      restartSwiper: false,
      currentPos: [],
      distance: [],
      filterSteps: {
        slides: true,
        filter: true,
      },
    }
  },
  computed: {
    ...mapState('client', ['companySettings']),
    isMobile() {
      return isMobileDevice()
    },
    cSwiperOption() {
      return this.isMobile ? this.mobileSwiperOption : this.swiperOption
    },
    advPositions() {
      // возвращает список позиций в списке, на которые вкорячиваем реккламу. zero-based.
      if (!this.companySettings.is_enabled_adv)
        return [];
      if (!this.salons || this.salons.length === 0) {
        // нет филиалов - нет рекламы
        return [];
      }
      if (this.salons.length === 0) {
        return [];
      } else if (this.salons.length === 1) {
        // 1 филиал - вставляем рекламу после него
        return [1];
      } else if (this.salons.length === 2) {
        // два филиала - между первым и вторым
        return [1];
      } else if (this.salons.length > 2) {
        // три и более филиала - после второго и где-нибудь ещё
        let random = this.randomInteger(2, this.salons.length);
        return [1, random];
      }
    },
    slides() {
      let salons = this.salons.length && this.salons.slice().sort((a, b) => a.distance - b.distance); // clone the salons list
      //all adsenseContent variables turn to false
      // if (this.el) {
      //   const positions = this.advPositions && this.advPositions.sort((a,b)=>a-b).reverse();
      //   let hasAds = salons && salons.filter(e => e.adsenseContent)
      //   // reverse - чтобы вставлять с конца, чтобы индексы не сбивались
      //   // if((positions && positions.length) && !hasAds.length) {
      //   //   for (let x of positions){
      //   //     salons.splice(x, 0, {adsenseContent: false})
      //   //   }
      //   // }
      // }
      return salons;
    },
    routerQuery() {
      return this.$route.query
    }
  },
  methods: {
    ...mapActions("client", ["selectSalon"]),
    randomInteger(min, max) {
      let rand = min + Math.random() * (max + 1 - min);
      return Math.floor(rand);
    },
    slideTo(slide) {
      let index = this.slides && this.slides.length && this.slides.findIndex(el => parseInt(el.id) === parseInt(slide)) || [];
      this.$refs && this.$refs.mySwiper && this.$refs.mySwiper.swiper.slideTo(index, 1000, false);
    },
  },
  mounted() {
    this.el = this.$el;
    if (this.$route.query && this.$route.query.slide) {
      this.slideTo(this.$route.query.slide)
    }
  },
  watch: {
    routerQuery(val, old) {
      if (parseInt(val.slide) !== parseInt(old.slide))
        this.slideTo(val.slide)
    },
  }
};
</script>

<style scoped>
.swipper-slider {
  padding: 0 20px;
  min-width: 251px;
}

.client-slider__click-wrap.ads {
  margin-top: 18px;
  padding: 0;
  align-items: center;
}
</style>
